import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

/**
 * #28 — SEO breadcrumbs with schema.org JSON-LD.
 * Pass items as [{ label, to? }] — last item is current (no link).
 */
export default function Breadcrumbs({ items = [] }) {
  if (!items.length) return null;

  const ldJson = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.label,
      ...(it.to ? { item: `${window.location.origin}${it.to}` } : {}),
    })),
  };

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-[11px] font-sans" data-testid="breadcrumbs">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(ldJson) }} />
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={i} className="flex items-center gap-1.5">
            {it.to && !last ? (
              <Link
                to={it.to}
                className="text-white/40 hover:text-[#D4AF37] uppercase tracking-[0.15em] transition-colors"
              >
                {it.label}
              </Link>
            ) : (
              <span className={`uppercase tracking-[0.15em] ${last ? 'text-[#D4AF37]' : 'text-white/40'}`} aria-current={last ? 'page' : undefined}>
                {it.label}
              </span>
            )}
            {!last && <ChevronRight className="w-3 h-3 text-white/15" />}
          </span>
        );
      })}
    </nav>
  );
}
